import React from 'react';
import cn from 'clsx';

import Button from '../../library/button/button';
import { AngleLeftLightIcon } from '../../shared/icons/icons';

import styles from './back-button.scss';

interface BackButtonProps {
  className?: string;
  href?: string;
  onClick?: () => void;
  text?: string;
}

function BackButton(props: BackButtonProps) {
  const { className, href, onClick, text } = props;

  return (
    <Button
      className={cn(styles['back-button'], `${className || ''} back-button`)}
      href={href}
      onClick={() => {
        if (onClick) onClick();
      }}
      size="regular"
      type="button"
    >
      <AngleLeftLightIcon
        aria-hidden="true"
        className={cn(styles['back-icon'], 'back-button__back-icon')}
      />
      {text}
    </Button>
  );
}

export default BackButton;
